import { Module } from 'vuex'
import { state } from './state'
import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'
import { RootState } from 'store'
import { ManualState } from './types'

export const manual: Module<ManualState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}

